import {isNotNil} from 'ramda';

import {EntityHeaderFlag} from '@dms/shared';

import {Nullish} from 'shared/web';

const ADDITIONAL_INFORMATION_FLAG_COLOR = 'neutral';

export function getAdditionalInformationFlags(
  additionalInformation: ({message: string} | Nullish)[] | Nullish
): EntityHeaderFlag[] {
  return (
    additionalInformation?.flatMap((information) =>
      isNotNil(information)
        ? [
            {
              label: information.message,
              colorScheme: ADDITIONAL_INFORMATION_FLAG_COLOR,
              isSubtle: true,
            },
          ]
        : []
    ) ?? []
  );
}
